/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.CertificationDocumentListResponseDto>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/certificationDocument/list`, {
      method: "GET",

      ...options,
    }),
  );
}
